import { render, staticRenderFns } from "./ContactCompanyForm.vue?vue&type=template&id=23330c1e"
import script from "./ContactCompanyForm.vue?vue&type=script&lang=ts"
export * from "./ContactCompanyForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports